/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const SocialExportDailymotionSettingsDtoChannelEnum = {
    animals: "animals",
    creation: "creation",
    auto: "auto",
    school: "school",
    people: "people",
    fun: "fun",
    videogames: "videogames",
    tech: "tech",
    kids: "kids",
    lifestyle: "lifestyle",
    shortfilms: "shortfilms",
    music: "music",
    news: "news",
    sport: "sport",
    tv: "tv",
    travel: "travel",
    webcam: "webcam"
} as const;

export type SocialExportDailymotionSettingsDtoChannelEnumKey = (typeof SocialExportDailymotionSettingsDtoChannelEnum)[keyof typeof SocialExportDailymotionSettingsDtoChannelEnum];

export type SocialExportDailymotionSettingsDto = {
    /**
     * @description Marks the video as private when true
     * @default true
     * @type boolean
    */
    private?: boolean | null;
    /**
     * @description Indicates whether the video is suitable for kids
     * @default true
     * @type boolean | undefined
    */
    forKids?: boolean;
    /**
     * @description Dailymotion category id. See https://developers.dailymotion.com/api/platform-api/reference/#list-of-categories
     * @default "news"
     * @type string
    */
    channel?: SocialExportDailymotionSettingsDtoChannelEnumKey | null;
    /**
     * @description ISO-639-3 code
     * @type string
    */
    language?: string | null;
};